<div id="exportar-pdf">
  <section>
    <app-cabecalho-relatorio></app-cabecalho-relatorio>
    <app-rotulo-cabecalho [cliente]="relatorio?.cabecalho?.nomeCliente"
      [contrato]="relatorio?.cabecalho?.contratoCliente" [cnpj]="relatorio?.cabecalho?.cnpjCliente"
      [tipoDeContrato]="relatorio?.cabecalho?.tipoContratoCliente"
      [mesReferencia]="relatorio?.cabecalho?.vencimento?.mesReferencia"
      [vencimento]="relatorio?.cabecalho?.vencimento?.dataMes "
      [faturaNumero]="relatorio?.cabecalho?.vencimento?.numeroFatura" [valor]="relatorio?.cabecalho?.valorFatura"
      [dataEmissao]="relatorio?.cabecalho?.vencimento?.dataEmissao"
      [emissao]="relatorio?.cabecalho?.vencimento?.emissao">
    </app-rotulo-cabecalho>
  </section>
  <div *ngFor="let detalhe of relatorio?.detalhamento">
    <app-tabela-relatorio
    [equipamento]="detalhe?.nomeEquipamento"
      [cabecalhosTabela]="['PATRIMÔNIO', 'DESCRIÇÃO', 'VALOR MENSAL', 'CONTATO']">
      <tr *ngFor="let detalhesTabela of detalhe.informacoesTabela">
        <ng-container class="cabecalho__tabela">
          <td class="item__tabela">{{ detalhesTabela.patrimonio }}</td>
          <td class="item__detalhamento">{{ detalhesTabela.equipamento }}</td>
          <td class="item__tabela">R$ {{ detalhesTabela.valorMensal }}</td>
          <td class="item__tabela">{{ detalhesTabela.contato }}</td>
        </ng-container>
      </tr>
    </app-tabela-relatorio>
    <app-rodape-tabela-relatorios [tipoRelatorio]="relatorio?.cabecalho?.razaoNotaFiscalRelatorioTipo"
      [subTotalModeloInformatica]="detalhe?.subtotalModelo">
    </app-rodape-tabela-relatorios>
  </div>
  <app-rodape-relatorio [valorTotalDaFatura]="relatorio?.resumoTotal?.valorTotalFatura"
    [tipoRelatorio]="relatorio?.cabecalho?.razaoNotaFiscalRelatorioTipo"></app-rodape-relatorio>
